import {createSlice} from '@reduxjs/toolkit';

import {promotionCenterBuilder} from './reducer';

const initialState: any = {
  loading: 0,
  approveLoading: false,
  registerCampaignDefaultSelected: true,
  error: '',
  cycleData: [],
  productsTotalList: JSON.parse(localStorage.getItem('totalProducts') ?? 'null') || {},
  promotionCenterState: {cycleId: 0, state: 'market-party', status: 'register'},
  categoriesList: [],
  sortType: null,
  sortObject: {},
  filters: {updated: false},
  productsDetailsList: {pagination: {total_page: 0, page: 1, page_size: 10}, data: [], message: ''},
  productsDetailsPagination: {page: 1, pageSize: 10},
  selectedItems: 0,
  campaignItems: {pagination: {total_page: 0, page: 1, page_size: 10}, data: [], message: ''},
  campaignCycle: [],
  cycleHistory: [],
  cycleDetails: {},
  vendorsPromotions: null
};

export const promotionCenterSlicer = createSlice({
  name: 'promotionCenter',
  initialState,
  reducers: {
    setPromotionCenterState(state: any, action: any) {
      state.promotionCenterState = {
        state: action.payload.state,
        status: action.payload.status,
        cycleId: action.payload.cycleId
      };
    },
    setPagination(state: any, action: any) {
      state.productsDetailsPagination = {...state.productsDetailsPagination, page: action.payload};
    },
    updateProductsDetailsList(state: any, action: any) {
      const temp = JSON.parse(JSON.stringify(state.productsDetailsList));
      temp.data[action.payload.index] = action.payload.data;
      state.productsDetailsList = temp;
      const indexes: any = {discountIndex: null, productIndex: null};
      const totalProducts = JSON.parse(localStorage.getItem('totalProducts') ?? 'null');
      totalProducts.products.map((item, index) => {
        if (item.product_id === action.payload.data.productId) {
          indexes.discountIndex = action.payload.data.suggestedDiscount.findIndex(
            (discount) => discount.selected === true
          );
          indexes.productIndex = index;
        }
      });
      totalProducts.products[indexes.productIndex] = {
        ...totalProducts.products[indexes.productIndex],
        selected: action.payload.data.selected,
        vendor_default_discount:
          action.payload.data.suggestedDiscount[indexes.discountIndex].Option,
        snapp_default_discount: action.payload.data.suggestedDiscount[indexes.discountIndex].Option
      };
      localStorage.setItem('totalProducts', JSON.stringify(totalProducts));
      state.productsTotalList = totalProducts;
    },
    updateDiscountOption(state: any, action: any) {
      const temp = JSON.parse(JSON.stringify(state.cycleDetails));
      const totalProducts = JSON.parse(localStorage.getItem('totalProducts') ?? 'null');
      const newProducts = temp.products.map((product) => {
        const options = product.suggested_option.map((item) => {
          if (action.payload.value === item.option) {
            return {...item, data: {...item.data, selected: true}};
          } else {
            return {...item, data: {...item.data, selected: false}};
          }
        });
        return {...product, suggested_option: options};
      });
      state.cycleDetails = {...temp, products: newProducts};
      totalProducts.products.map((product) => {
        product.vendor_default_discount = action.payload.value;
      });
      localStorage.setItem('totalProducts', JSON.stringify(totalProducts));
      state.productsTotalList = totalProducts;
    },
    updateProduct(state: any, action: any) {
      const temp = JSON.parse(JSON.stringify(state.cycleDetails));
      temp.products[action.payload.index] = action.payload.data;
      state.cycleDetails = temp;
      const indexes: any = {discountIndex: null, productIndex: null};
      const totalProducts = JSON.parse(localStorage.getItem('totalProducts') ?? 'null');
      totalProducts.products.map((item, index) => {
        if (item.product_id === action.payload.data.id) {
          indexes.discountIndex = action.payload.data.suggested_option.findIndex(
            (discount) => discount.data.selected === true
          );
          indexes.productIndex = index;
        }
      });
      totalProducts.products[indexes.productIndex] = {
        ...totalProducts.products[indexes.productIndex],
        selected: action.payload.data.selected,
        vendor_default_discount: action.payload.data.suggested_option[indexes.discountIndex].option
      };
      localStorage.setItem('totalProducts', JSON.stringify(totalProducts));
      state.productsTotalList = totalProducts;
    },
    updateItemInProductsDetailsList(state: any, action: any) {
      const newProductDetailsList = JSON.parse(JSON.stringify(state.productsDetailsList));
      let productExists = false;
      newProductDetailsList.data.map((item, index) => {
        if (item.productId === action.payload.data.productId) {
          newProductDetailsList.data[index] = action.payload.data;
          productExists = true;
        }
      });
      if (!productExists) {
        newProductDetailsList.data.push(action.payload.data);
      }
      state.productsDetailsListFiltered.data[action.payload.index] = action.payload.data;
      state.productsDetailsList = newProductDetailsList;
    },
    updateRegisterCampaignDefaultSelected(state: any) {
      state.registerCampaignDefaultSelected = !state.registerCampaignDefaultSelected;
    },
    updateSelectedItems(state: any, action: any) {
      state.selectedItems = action.payload;
    },
    updateAllSelectedItems(state: any, action: any) {
      state.selectedItems = action.payload ? state.productsTotalList.products.length : 0;
      const newCycleDetails = JSON.parse(JSON.stringify(state.cycleDetails));
      const newTotalProductsList = JSON.parse(localStorage.getItem('totalProducts') ?? 'null');
      newCycleDetails.products.map((item) => {
        item.selected = action.payload;
      });
      state.cycleDetails = newCycleDetails;
      newTotalProductsList.products.map((item) => {
        item.selected = action.payload;
      });
      localStorage.setItem('totalProducts', JSON.stringify(newTotalProductsList));
      state.productsTotalList = newTotalProductsList;
    },
    emptyProductsDetailsList(state: any) {
      state.productsDetailsList = initialState.productsDetailsList;
    },
    updateCategoriesSelected(state: any, action: any) {
      const newCategories = JSON.parse(JSON.stringify(state.categoriesList));
      state.categoriesList = newCategories.map((i, index) =>
        i.id === action.payload.id ? (newCategories[index] = {...i, selected: !i.selected}) : i
      );
    },
    clearFilterCategories(state: any, action: any) {
      state.categoriesList = action.payload;
    },
    updateSortType(state: any, action: any) {
      state.sortType = action.payload;
    },
    clearSortType(state: any) {
      state.sortType = null;
    },
    setFilters(state: any, action: any) {
      state.filters = action.payload;
    },
    updateFiltersSort(state: any, action: any) {
      state.filters = {
        ...state.filters,
        sort_by: action.payload.sort_by,
        sort_type: action.payload.sort_type
      };
    }
  },
  extraReducers: promotionCenterBuilder
});

export const {
  setPromotionCenterState,
  setPagination,
  updateProductsDetailsList,
  updateProduct,
  updateDiscountOption,
  updateItemInProductsDetailsList,
  updateRegisterCampaignDefaultSelected,
  updateSelectedItems,
  emptyProductsDetailsList,
  updateAllSelectedItems,
  updateCategoriesSelected,
  clearFilterCategories,
  clearSortType,
  updateSortType,
  setFilters,
  updateFiltersSort
} = promotionCenterSlicer.actions;
export default promotionCenterSlicer.reducer;
